import {
Component,
Injector,
Optional
} from '@angular/core';
import {CommonModule} from "@angular/common";

import { DISPLAY_TYPE, IWidgetConfig, StylableComponent, provideAsWidgetRef, Parent, register, styler, APPLY_STYLES_TYPE } from "@wm/components-base";
import{ runtimeEventManager } from "@wm/core";


const DEFAULT_CLS = 'btn app-camera';
const WIDGET_CONFIG: IWidgetConfig = {
  widgetType: 'wm-camera',
  hostClass: DEFAULT_CLS,
  displayType: DISPLAY_TYPE.INLINE_BLOCK
};

@Component({
  selector: 'button[wmCamera]',
  template: `<i [ngClass]="iconclass" [ngStyle]="{'font-size': iconsize}"></i>`,
  providers: [
    provideAsWidgetRef(CameraComponent)
  ],
  exportAs: 'wmCamera',
  standalone: true,
  imports: [ CommonModule ],
  styles: []
})
export class CameraComponent extends StylableComponent {
  static initializeProps = register('wm-camera');
  public iconsize: any;
  public iconclass: any;

  constructor(inj: Injector,
              @Optional() viewParent: Parent) {
    super(inj, WIDGET_CONFIG, viewParent);
    styler(this.nativeElement, this);
  }

   override onPropertyChange(key: string, nv: any, ov?: any) {
    let wp : any= this.widgetProps;
    let showprops = false;
    if(key === 'capturetype'){
      if(nv === 'IMAGE'){
        showprops = true;
      }
      wp.imagequality.show        = showprops;
      wp.imageencodingtype.show   = showprops;
      wp.allowedit.show           = showprops;
      wp.imagetargetwidth.show    = showprops;
      wp.imagetargetheight.show   = showprops;
      runtimeEventManager.emit('wms:refresh-properties-panel');
    }
  }



}

